import { useEffect } from 'react';
import { ChevronLeft, X } from 'lucide-react';

/** A bottom sheet on phones, a centred dialog on wide screens. */
export function Sheet({
  title,
  onClose,
  onBack,
  children
}: {
  title: string;
  onClose: () => void;
  /** Shows a back arrow (e.g. from a form back to the list of things to log). */
  onBack?: () => void;
  children: React.ReactNode;
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center md:items-center" role="dialog" aria-modal="true" aria-label={title}>
      <button type="button" className="absolute inset-0 bg-black/40" aria-label="Close" onClick={onClose} />
      <div className="safe-bottom relative max-h-[92dvh] w-full max-w-md overflow-y-auto rounded-t-2xl bg-clinical-card p-4 shadow-xl md:rounded-2xl">
        <div className="mb-3 flex items-center gap-1">
          {onBack ? (
            <button type="button" onClick={onBack} className="focus-ring -ml-2 rounded-lg p-2 text-clinical-muted" aria-label="Back">
              <ChevronLeft className="h-5 w-5" />
            </button>
          ) : null}
          <h2 className="flex-1 text-lg font-semibold">{title}</h2>
          <button type="button" onClick={onClose} className="focus-ring rounded-lg p-2 text-clinical-muted" aria-label="Close">
            <X className="h-5 w-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
